import React from 'react';
const Divider = () => /*#__PURE__*/React.createElement("div", {
  className: "margin-responsive-tb"
}, /*#__PURE__*/React.createElement("hr", {
  className: "color-border-subtle"
}));
export default Divider;